var React = require('react');

function Success (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"15","cy":"15","r":"15","fill":"#95BA34","key":0}),React.createElement("path",{"d":"M11.2512 20.555L7 16.2225L8.4165 14.7781L12.6666 19.1118L22.5835 9L24 10.4443L12.6677 21.9994L12.6661 22L11.2512 20.555Z","fill":"white","key":1})]);
}

Success.defaultProps = {"viewBox":"0 0 30 30","fill":"none"};

module.exports = Success;

Success.default = Success;
